import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=44e8e8ce&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e8e8ce')) {
      api.createRecord('44e8e8ce', component.options)
    } else {
      api.reload('44e8e8ce', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=44e8e8ce&", function () {
      api.rerender('44e8e8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23W9Ka7D4pcPK/JS/comp/pricelist.vue"
export default component.exports